// in src/MyLayout.js
import * as React from "react";
import { Layout } from "react-admin";
import MySidebar from "./MySidebar";
import MyAppBar from "./MyAppBar";
import { MyNotification } from "./MyNotification";

const MyLayout = (props) => (
  <Layout
    {...props}
    appBar={MyAppBar}
    sidebar={MySidebar}
    notification={MyNotification}
  />
);

export default MyLayout;
